import type { FC, ReactNode } from 'react';

// Inline, not `aspect-video`: Orchid's Tailwind theme replaces aspectRatio, so the
// utility is not generated there and absolutely positioned content collapses to 0.
const VIDEO_ASPECT = { aspectRatio: '16 / 9' };

// A neutral card for a video with no picture to show, such as an upload in progress
// or a failed video. Padded so its content never sits flush against the rounded edge.
export const VideoCardShell: FC<{ status?: string; videoId?: string; children: ReactNode }> = ({
  status,
  videoId,
  children,
}) => (
  <div
    className="flex w-full flex-col items-center justify-center gap-2 rounded-xl border border-black/10 bg-black/5 p-6 text-black/50"
    style={VIDEO_ASPECT}
    data-video-id={videoId}
    data-video-status={status}
  >
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M4 6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6Zm12 4.5 4-2.5v8l-4-2.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
    {children}
  </div>
);
